import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Input, Button } from '../../components/ds';
import logoWhite from '../../assets/vmfive-logo-white.png';
import './LoginPage.css';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/accounts');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* Left: Brand / Visual Panel */}
      <div className="login-visual">
        <div className="login-visual__content">
          <div className="login-visual__logo">
            <img src={logoWhite} alt="VMFIVE" className="login-visual__logo-img" />
          </div>
          <p className="login-visual__tagline">
            管理您的廣告並追蹤投放成效。
          </p>
        </div>
      </div>

      {/* Right: Form Panel */}
      <div className="login-form-panel">
        <div className="login-form__header">
          <div className="login-form__subtitle">管理後台</div>
          <h1 className="login-form__title">歡迎回來</h1>
          <p className="login-form__desc">請輸入帳號密碼以登入管理後台</p>
        </div>

        <form onSubmit={handleSubmit}>
          <Input
            label="電子郵件"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@vmfive.com"
            required
          />

          <Input
            label="密碼"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="請輸入密碼"
            required
          />

          {error && <div className="login-error">{error}</div>}

          <div className="login-form__actions">
            <Button
              type="submit"
              disabled={loading}
              className="login-btn"
            >
              {loading ? '登入中...' : '登入'}
            </Button>
          </div>
        </form>

        <div className="login-form__footer">
          需要協助？請聯繫 <a href="mailto:support@vmfive.com">support@vmfive.com</a>
        </div>
      </div>
    </div>
  );
}
